export default __webpack_public_path__ + "static/media/kleaderboard.9300259c.png";